import React, {Component} from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Carousel } from 'react-responsive-carousel';
import {console_log} from "../../utils/helper";
import { config } from '../../constants/domainConfig'
import { isGamiclub } from '../../constants/isGamiclub';
class Banner extends Component {

    constructor(props) {
        super(props);
    }
    onclick(id){
        if(id != undefined){
            //if (config.subDomain === "my") {
                window.location.href = '#/category/' + id + '?uid=' + this.props.access.uid;
            /*}
            else {
                window.location.href = '#/detail/' + id + '?uid=' + this.props.access.uid;
            } */   
        }
    }
    getItem(data, i) {
        const url = window.location.hash;
        return (
            <div key={i} onClick={()=>this.onclick(data.id)} className={url=='#/home/html' || url=='#/home/android' || url=='#/home/video' || config.subDomain == 'tr' ? "banner-item" : "banner-item striped-lines-bg"}>
                <img src={data.imgUrl} alt={data.game_name.toUpperCase()} />
                {(data.offer) ?
                    <div className="ribbon">
                        <span className="ribbon-content">{data.offer.toUpperCase()}</span>
                    </div>
                    : ''}
                <div className="banner-text">
                    <span style={isGamiclub ? {color: 'green'} : null} className="game-name">{data.game_name.toUpperCase()}</span>
                    <span className="category-name">{data.category_name.toUpperCase()}</span>
                </div>
            </div>
        )
    }

    render() {
        let data = this.props.bannerData;
        return (
            <section className="banner">
                <Carousel swipeable={true} autoPlay={true} interval={3000} showArrows={false} showThumbs={false} infiniteLoop={true} transitionTime={350} emulateTouch={true} showIndicators={(data.length > 1)}>
                    {
                        data.map((image, i) => this.getItem(image, i))
                    }
                </Carousel>
            </section>
        );
    }
}


const mapStateToProps = (state) => {
    return {
        access: state.WelcomeReducer
    };
};
const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(Banner);


// WEBPACK FOOTER //
// ./src/components/Banner/Banner.js